import React, { useState } from "react";
import TopBar from "./TopBar";
import logo from "../../assets/1x/icone.png";
import logor from "../../assets/1x/icone blanc.png";
import { NavLink } from "react-router-dom";
import {
  ArrowDown01Icon,
  ArrowRight01Icon,
  ArrowRightDoubleIcon,
  Cancel01Icon,
  DashboardBrowsingIcon,
  Logout01Icon,
  Menu01Icon,
  Settings01Icon
} from "hugeicons-react";
import { useNavigate } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import { FlagIcon } from "react-flag-kit";
import $ from "jquery";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/slices/auth.slice";
import { BaseUrl } from "../../config";
import { useAuth } from "../../context/authContext";
import ImageUI from "../ui/Image";
import { PathLink } from "../../utils/PathLink";
// import menuData from "../../datas/menu.json";

export function ServicesMenu({ label, x, t, servicePreload }) {
  return (
    <div className="flex flex-col gap-2">
      <NavLink
        to={PathLink(`/${label}/${label?.toLowerCase() === "services" ? x?.link : x?.titre}`)}
        onMouseEnter={servicePreload}
        className="flex text-[1.1rem] font-medium capitalize hover:text-secondary items-center gap-1"
      >
        <ArrowRightDoubleIcon color="#E30713" />
        {x.titre}
      </NavLink>
      <span className="text-[.85rem] max-md:hidden text-gray-600 font-extralight text-justify h-[60px] overflow-hidden text-ellipsis">
        {x.descrip}
      </span>
      <NavLink
        to={PathLink(`/${label}/${label?.toLowerCase() === "services" ? x?.link : x?.titre}`)}
        onMouseEnter={servicePreload}
        className="text-secondary max-md:hidden"
      >
        {t('readMore')}...
      </NavLink>
    </div>
  );
}

export function AfricaMenu({ x, preloadBureauAfriqZ, changePageMenu }) {
  return (
    <div className="flex flex-col gap-2">
      <span
        onClick={() =>
          changePageMenu(`Bureau/Afrique/${x.titre}`)
        }
        onMouseEnter={preloadBureauAfriqZ}
        className="flex cursor-pointer text-[1.1rem] font-medium capitalize transition-all duration-300 hover:text-secondary items-center gap-1"
      >
        <ArrowRightDoubleIcon color="#E30713" />
        {x.titre}
      </span>
      <ul className="text-[.95rem] max-md:hidden !bg-transparent flex flex-col gap-2 font-medium text-justify">
        {x.pays?.map((y, indexs) => (
          <li
            key={indexs}
            className="bg-transparent cursor-pointer hover:text-secondary"
          >
            <NavLink to={PathLink(`/Bureau/Afrique/${x.titre}/${y.nom}`)} onMouseEnter={preloadBureauAfriqZ}>
              {y.nom}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Navsbar() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();


  const [open, setOpen] = useState(false);
  const [opens, setOpens] = useState(false);
  const [opena, setOpena] = useState(false);
  const [openba, setOpenba] = useState(false);
  const [openca, setOpenca] = useState(false);
  const [mobileopen, setMobileopen] = useState(false);

  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const [language, setLanguage] = useState(localStorage.getItem("i18nextLngsa") || i18n.language); // Langue par défaut: anglais

  const handleOpens = () => {
    setOpen(false);
    setOpena(false);
    setOpenba(false);
    setOpenca(false);
    setOpens(!opens);
  };
  const handleOpena = () => {
    setOpen(false);
    setOpenba(false);
    setOpenca(false);
    setOpens(false);
    setOpena(!opena);
  };
  const handleOpenba = () => {
    setOpen(false);
    setOpena(false);
    setOpenca(false);
    setOpens(false);
    setOpenba(!openba);
  };
  const handleOpenca = () => {
    setOpen(false);
    setOpena(false);
    setOpens(false);
    setOpenba(false);
    setOpenca(!openca);
  };
  const changePageMenu = (x) => {
    setOpen(false);
    setOpena(false);
    setOpens(false);
    setOpenba(false);
    setOpenca(false);
    setMobileopen(false);
    $(".navsbar").removeClass("active");
    $(".mobiles").removeClass("fixed");
    navigate(PathLink(`/${x}`));
  };

  const handleScrolle = () => {
    const scrol = $(window).scrollTop();
    if (scrol >= 160) {
      $(".logo-scroll").removeClass("hidden");
    } else {
      $(".logo-scroll").addClass("hidden");
    }
    if (scrol >= 300) {
      setOpen(false);
      setOpena(false);
      setOpens(false);
      setOpenba(false);
      setOpenca(false);
    }
  };
  window.addEventListener("scroll", handleScrolle);

  const handleMenuOpen = () => {
    // setMobileopen(true);
    $(".openm").removeClass("show");
    $(".closem").removeClass("unshow");
    $(".openm").addClass("unshow");
    $(".closem").addClass("show");
    $(".mobiles").addClass("absolute");
    $(".navsbar").addClass("active");
    // $('#root').addClass('overflow-hidden')
  };
  const handleMenuClose = () => {
    $(".openm").removeClass("unshow");
    $(".closem").removeClass("show");
    $(".openm").addClass("show");
    $(".closem").addClass("unshow");
    $(".mobiles").removeClass("absolute");
    $(".navsbar").removeClass("active");
  };

  const toggleLanguageMenu = () => {
    setShowLanguageMenu(!showLanguageMenu);
  };

  const getFlag = (lang) => {
    switch (lang) {
      case "fr":
        return <FlagIcon code="FR" size={16} />;
      case "de":
        return <FlagIcon code="DE" size={16} />;
      case "es":
        return <FlagIcon code="ES" size={16} />;
      case "dk":
        return <FlagIcon code="DK" size={16} />;
      case "nl":
        return <FlagIcon code="NL" size={16} />;
      default:
        return <FlagIcon code="GB" size={16} />;
    }
  };

  const handleChangeLanguage = async (lng) => {
    if (!i18n.hasResourceBundle(lng, "translation")) {
      try {
        await i18n.loadLanguages(lng); // Charger la langue dynamiquement
      } catch (error) {
        console.error("Erreur lors du chargement de la langue :", error);
      }
    }
    i18n.changeLanguage(lng); // Changer la langue après le chargement
    setLanguage(lng);
    setShowLanguageMenu(false);
    navigate(PathLink());
  };


  const [opan, setOpan] = useState(false);
  // const { user } = useSelector((state) => state.auth);

  const devenirMemebre = () => import("../../pages/DevenirMembre");
  const leadership = () => import("../../pages/NosExperts");
  const presentationPreload = () => import("../../pages/Apropos/Presentations");
  const servicePreload = (item) => import("../../pages/Services/ServiceDetails");
  const eventPreload = () => import("../../pages/Evenements");
  const eventDetailPreload = () => import('../../pages/Evenements/DetailEvenements');
  const preloadBureauAfriqReg = () => import("../../pages/Bureau-Afrique/Pays");
  const preloadActiviteDetail = () => import("../../pages/Activites/ActiviteDetail");
  const preloadBureauAfriqZ = () => import("../../pages/Bureau-Afrique/Zone");

  const preloadActualite = () => import("../../pages/Actualites/index");
  const preloadActualiteDetail = () => import('../../pages/Bureau-Afrique/Zone');
  const preloadCccarevue = () => import("../../pages/CccaRevue");

  const data = [
    {
      link: "Entrepreneuriat",
      titre: t('serv.entrepreneur'),
      descrip:
        t('serv.desc1')
    },
    {
      link: "Francophonie",
      titre: t('serv.francophonie'),
      descrip:
        t('serv.desc2')
    },
    {
      link: "Repreunariat",
      titre: t('serv.repreunariat'),
      descrip:
        t('serv.desc4')
    },
    {
      link: "Coopération Internationale",
      titre: t('serv.cooperation'),
      descrip:
        t('serv.desc3')
    },
    {
      link: "Maillage d'Affaires",
      titre: t('serv.maillage'),
      descrip:
        t('serv.desc5')
    },
    {
      link: "Programme de Mentorat",
      titre: t('serv.mentorat'),
      descrip:
        t('serv.desc6')
    },
    {
      link: "Formations",
      titre: t('serv.formations'),
      descrip:
        t('serv.desc7')
    },
    {
      link: "Incubations",
      titre: t('serv.incubations'),
      descrip:
        t('serv.desc8')
    }
  ];

  const afrique = [
    {
      titre: "Afrique Centrale",
      pays: [
        {
          nom: "Cameroun",
          link: "#"
        },
        {
          nom: "Angola",
          link: "#"
        },
        {
          nom: "Congo",
          link: "#"
        },
        {
          nom: "Tchad",
          link: "#"
        },
        {
          nom: "Gabon",
          link: "#"
        },
        {
          nom: "Sao Tomé-et-Principe",
          link: "#"
        },
        {
          nom: "Guinée équatoriale",
          link: "#"
        },
        {
          nom: "République Centrafricaine",
          link: "#"
        }
      ]
    },
    {
      titre: "Afrique de l'Ouest",
      pays: [
        {
          nom: "Nigeria",
          link: "#"
        },
        {
          nom: "Bénin",
          link: "#"
        },
        {
          nom: "Burkina Faso",
          link: "#"
        },
        {
          nom: "Cap-vert",
          link: "#"
        },
        {
          nom: "Senégal",
          link: "#"
        },
        {
          nom: "Côte d'ivoire",
          link: "#"
        },
        {
          nom: "Gambie",
          link: "#"
        },
        {
          nom: "Ghana",
          link: "#"
        },
        {
          nom: "Guinée",
          link: "#"
        },
        {
          nom: "Guinée-Bissau",
          link: "#"
        },
        {
          nom: "Libéria",
          link: "#"
        },
        {
          nom: "Mali",
          link: "#"
        }
      ]
    },
    {
      titre: "Afrique de L'est",
      pays: [
        {
          nom: "Burundi",
          link: "#"
        },
        {
          nom: "Kenya",
          link: "#"
        },
        {
          nom: "Djibouti",
          link: "#"
        },
        {
          nom: "Malawi",
          link: "#"
        },
        {
          nom: "Maurice",
          link: "#"
        },
        {
          nom: "Mozambique",
          link: "#"
        },
        {
          nom: "Rwanda",
          link: "#"
        },
        {
          nom: "Ouganda",
          link: "#"
        },
        {
          nom: "Zambie",
          link: "#"
        }
      ]
    },
    {
      titre: "Afrique du Nord",
      pays: [
        {
          nom: "Algérie",
          link: "#"
        },
        {
          nom: "Égypte",
          link: "#"
        },
        {
          nom: "Libye",
          link: "#"
        },
        {
          nom: "Maroc",
          link: "#"
        },
        {
          nom: "Mauritanie",
          link: "#"
        },
        {
          nom: "Soudan",
          link: "#"
        },
        {
          nom: "Tunisie",
          link: "#"
        }
      ]
    },
    {
      titre: "Afrique Australe",
      pays: [
        {
          nom: "Botswana",
          link: "#"
        },
        {
          nom: "Lesotho",
          link: "#"
        },
        {
          nom: "Namibie",
          link: "#"
        },
        {
          nom: "Suaziland",
          link: "#"
        },
        {
          nom: "Afrique du Sud",
          link: "#"
        }
      ]
    },
    {
      titre: "Océan Indien",
      pays: [
        {
          nom: "Comore",
          link: "#"
        },
        {
          nom: "Madagascar",
          link: "#"
        }
      ]
    }
  ];

  const canada = [
    {
      titre: "Alberta"
    },
    {
      titre: "Colombie-Britannique"
    },
    {
      titre: "Île-du-Prince-Édouard"
    },
    {
      titre: "Manitoba"
    },
    {
      titre: "Nouvelle-Écosse"
    },
    {
      titre: "Québec"
    },
    {
      titre: "Saskatchewan"
    },
    {
      titre: "Terre-Neuve-et-Labrador"
    }
  ];

  const activite = [
    {
      titre: t('activitt.act1.titre'),
      descrip: t('activitt.act1.descrip')
    },
    {
      titre: t('activitt.act2.titre'),
      descrip: t('activitt.act2.descrip')
    },
    {
      titre: t('activitt.act3.titre'),
      descrip: t('activitt.act3.descrip')
    },
    {
      titre: t('activitt.act4.titre'),
      descrip: t('activitt.act4.descrip')
    },
    {
      titre: t('activitt.act5.titre'),
      descrip: t('activitt.act5.descrip')
    },
    {
      titre: t('activitt.act6.titre'),
      descrip: t('activitt.act6.descrip')
    },
    {
      titre: t('activitt.act7.titre'),
      descrip: t('activitt.act7.descrip')
    },
    {
      titre: t('activitt.act8.titre'),
      descrip: t('activitt.act8.descrip')
    },
    {
      titre: t('activitt.act9.titre'),
      descrip: t('activitt.act9.titre')
    },
    {
      titre: t('activitt.act10.titre'),
      descrip: t('activitt.act10.descrip')
    }
  ];

  const { userConnected, handleLogout } = useAuth();
  // const texte=`<strong class='underline underline-offset-2 capitalize'>${t('annonce')}</strong> :  ${t('communique')}`
  return (
    <>
      <TopBar />
      <div className="relative px-[5%] py-8 bg-white flex items-center max-lg:hidden justify-between">
        <div className="">
          <NavLink to={PathLink()} className="flex  items-center gap-1">
            <img loading="lazy" src={logo} width={45} height={45} alt="logo_ccca" />
            <div className="flex flex-col font-semibold text-[1.13rem] leading-[1.4rem]">
              <span>Chambre de Commerce</span>
              <span className="text-primary font-bold">Canada-Afrique</span>
            </div>
          </NavLink>
        </div>
        <div className="flex gap-3 items-center ">
          <NavLink
            to={PathLink("/nos-experts/leadership")}
            className="px-5 py-1.5 rounded-[5px] bg-primary text-white hover:underline max-md:hidden font-semibold text-[.88rem]">
            {t("nosExpert")}
          </NavLink>
          <NavLink
            to={PathLink("/Devenir-membre")}
            onMouseEnter={devenirMemebre}
            className="px-5 py-1.5 bg-primary text-white rounded-[5px] text-[.88rem] hover:underline font-semibold">
            {t("becomeMember")}
          </NavLink>
        </div>
      </div>


      <div className="mobiles !sticky top-0 transition-all duration-500 bg-secondary bar-rouge w-full px-[5%] z-[100] font-medium flex justify-between items-center gap-1">
        <div className="items-center gap-1 max-md:py-2 logo-mobile">
          <img loading="lazy" src={logor} width={35} height={35} alt="logo_ccca" />
          <div className="flex flex-col text-white font-semibold text-[.85rem] leading-[1rem]">
            <span>Chambre de commerce</span>
            <span>Canada Afrique</span>
          </div>
        </div>
        <ul className="text-white text-[.9rem] font-medium shadow-sm navsbar transition-all duration-500 overflow-y-auto">
          <li className="za logo-scroll transition-all duration-500 hidden max-md:hidden">
            <NavLink to={PathLink()} className="block px-4 py-2 navlink">
              <img loading="lazy" src={logor} className="w-[45px] h-[35px]" width={35} height={35} alt="#" />
            </NavLink>
          </li>

          <li className="cursor-pointer za">
            <NavLink
              to={PathLink(`/Apropos-de-nous/Présentation`)}
              onMouseEnter={presentationPreload}
              className="block px-4 py-4 navlink"
            >
              {t('aboutUs')}
            </NavLink>
          </li>

          <li
            className={`cursor-pointer za ${opens ? "active" : ""}`}
            onClick={handleOpens}
          >
            <NavLink className="flex items-center gap-1 px-4 py-4 link navlink">
              {t('services')}
              <ArrowDown01Icon className="icones" size={"1.1rem"} />
            </NavLink>

            <div
              className={`left-[5%] text-black block-menu bg-gray-200 w-[90%] px-20 pt-7 pb-10`}
            >
              <div className="flex items-center font-semibold text-[1.1rem] gap-2 border-b-[3px] border-secondary pb-2">
                <h4>{t('services')}</h4>
                <ArrowRight01Icon className="" size="1rem" />
              </div>
              <div className="grid grid-cols-3 gap-12 mt-4 text-black max-md:grid-cols-1 gap-y-7 max-md:gap-4">
                {data?.map((x, index) => (
                  <ServicesMenu label="Services" t={t} x={x} key={index} servicePreload={servicePreload} />
                ))}
              </div>
            </div>
          </li>
          <li className="cursor-pointer za">
            <NavLink to={PathLink("/Evenements")} onMouseEnter={eventPreload} className="block px-4 py-4 navlink">
              {t('events')}
            </NavLink>
          </li>
          <li
            className={`cursor-pointer za ${opena ? "active" : ""}`}
            onClick={handleOpena}
          >
            <NavLink className="px-4 z-[100] link flex py-4 gap-1 items-center navlink">
              {t('activities')}
              <ArrowDown01Icon className="icones" size={"1.1rem"} />
            </NavLink>
            <div
              className={`left-[5%] text-black block-menu top-[100%] bg-gray-200 w-[90%] px-20 pt-7 pb-10`}
            >
              <div
                // onClick={() => navigate("/a/Activites/List")}
                // onMouseEnter={preloadActivite}
                className="flex items-center font-semibold text-[1.1rem] gap-2 border-b-[3px] border-secondary pb-2"
              >
                <h4>{t('activities')}</h4>
                <ArrowRight01Icon className="" size="1rem" />
              </div>
              <div className="grid grid-cols-3 gap-12 mt-4 text-black max-md:grid-cols-1 gap-y-7 max-md:gap-4 sous-bl">
                {activite?.map((x, index) => (
                  <ServicesMenu label="Activites" t={t} x={x} key={index} servicePreload={preloadActiviteDetail} />

                ))}
              </div>
            </div>
          </li>
          <li
            className={`cursor-pointer za ${openba ? "active" : ""}`}
            onClick={handleOpenba}
          >
            <NavLink className="flex items-center gap-1 px-4 py-4 link navlink">
              {/* {t('africaOffices')}  */}
              Nos Représentations
              <ArrowDown01Icon className="icones" size={"1.1rem"} />
            </NavLink>
            <div
              className={`left-[5%] text-black block-menu top-[100%] bg-gray-200 w-[90%] px-20 pt-7 pb-10`}
            >
              <div className="flex items-center font-semibold text-[1.1rem] gap-2 border-b-[3px] border-secondary pb-2">
                <h4>{t('africaOffices')}</h4>
                <ArrowRight01Icon className="" size="1rem" />
              </div>
              <div className="grid grid-cols-3 gap-12 mt-4 text-black max-md:grid-cols-1 gap-y-7 max-md:gap-4">
                {afrique?.map((x, index) => (
                  <AfricaMenu key={index} x={x} preloadBureauAfriqReg={preloadBureauAfriqReg} changePageMenu={changePageMenu} />
                ))}
              </div>
            </div>
          </li>
          <li
            className={`cursor-pointer za ${openca ? "active" : ""}`}
            onClick={handleOpenca}
          >
            <NavLink className="flex items-center gap-1 px-4 py-4 link navlink">
              {t('canadaRepresentation')}
              <ArrowDown01Icon className="icones" size={"1.1rem"} />
            </NavLink>
            <div
              className={`left-[5%] w-[90%] text-black block-menu top-[100%] bg-gray-200 px-20 pt-7 pb-10`}
            >
              <div className="flex items-center font-semibold text-[1.1rem] gap-2 border-b-[3px] border-secondary pb-2">
                <h4>{t('canadaRepresentation')}</h4>
                <ArrowRight01Icon className="" size="1rem" />
              </div>
              <div className="grid grid-cols-3 gap-12 mt-4 text-black max-md:grid-cols-1 gap-y-7 max-md:gap-4">
                {canada?.map((x, index) => (
                  <div key={index} className="flex flex-col gap-2">
                    <NavLink
                      to={PathLink(`/Bureau/Canada/all/${x.titre}`)}
                      onMouseEnter={preloadBureauAfriqReg}
                      className="flex text-[1.1rem] font-medium cursor-pointer capitalize transition-all duration-300 hover:text-secondary items-center gap-1"
                    >
                      <ArrowRightDoubleIcon color="#E30713" />
                      {x.titre}
                    </NavLink>

                  </div>
                ))}
              </div>
            </div>
          </li>
          {/* <li
            className="cursor-pointer za"
          >
            <NavLink to={`/a/centrale_d_achat`} onMouseEnter={preloadActualite} className="block px-5 py-4 navlink">
            Centrale d'Achats
            </NavLink>
          </li> */}
          <li
            className="cursor-pointer za"
          >
            <NavLink to={PathLink(`/Actualites`)} onMouseEnter={preloadActualite} className="block px-5 py-4 navlink">
              {t('news')}
            </NavLink>
          </li>
          <li
            className="cursor-pointer za"
          >
            <NavLink to={PathLink(`/CCCA REVUE`)} onMouseEnter={preloadCccarevue} className="block px-4 py-4 navlink">
              CCCA REVUE
            </NavLink>
          </li>


          <li className="cursor-pointer za hidden max-sm:block">
            <NavLink to={PathLink(`/nos-experts/leadership`)} className="block px-4 py-4 navlink">
              {t("nosExpert")}
            </NavLink>
          </li>
          <li className="derniers">
            <NavLink
              className="py-4 px-3 text-center font-semibold text-[.95rem] border-b-[1px] border-gray-300"
              to={PathLink("/Devenir-membre")}
              onMouseEnter={devenirMemebre}>
              Dévenir Membre
            </NavLink>
            <div className="flex items-center">
              <div className="w-[70%] px-[9%] py-3 border-r-[1px] font-semibold text-[.95rem] border-gray-300">
                {userConnected ? (
                  <div className="relative inline-block text-left">
                    <div
                      onClick={() => setOpan(!open)}
                      className="text-[.8rem] cursor-pointer capitalize font-semibold flex gap-2.5 items-center px-0">
                      <ImageUI src={BaseUrl + "/" + userConnected?.profile} alt={userConnected?.username} data={userConnected?.username} width={35} height={35} />
                      {userConnected?.prenom + " " + userConnected?.nom}
                    </div>
                    {opan && userConnected?.role === "admin" && (
                      <div className="absolute z-[1000] bottom-[135%] left-[5%] text-[.8rem] w-50 bg-white rounded-lg border border-gray-200 overflow-hidden">
                        <ul className="py-2 text-gray-800">
                          <li className="">
                            <NavLink
                              to="/admin/dashboard"
                              className="px-5 py-3 hover:bg-gray-100 cursor-pointer flex items-center gap-3 transition-all">
                              <DashboardBrowsingIcon className="w-4 h-4 text-gray-600" /> Dashboard
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              to="#"
                              className="px-5 py-3 hover:bg-gray-100 cursor-pointer flex items-center gap-3 transition-all">
                              <Settings01Icon className="w-4 h-4 text-gray-600" /> Paramètres
                            </NavLink>
                          </li>
                          <li
                            onClick={handleLogout}
                            className="px-5 py-3 hover:bg-gray-100 cursor-pointer flex items-center gap-3 transition-all text-red-600 border-t border-gray-200">
                            <Logout01Icon className="w-4 h-4" /> Déconnexion
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                ) : (
                  <NavLink to={"/login"} className="">
                    {t("login")}
                  </NavLink>
                )}
              </div>

              <button
                onClick={toggleLanguageMenu}
                className="!flex items-center text-[.7rem] w-[30%] px-4 py-3 justify-center gap-2 cursor-pointer"
                title="Changer de langue">
                {getFlag(language)} <FaChevronDown />
              </button>
              {showLanguageMenu && (
                <div className="absolute right-0 top-0 mt-2 z-[1000] bg-white border border-gray-300 rounded shadow-lg w-40">
                  <div
                    onClick={() => handleChangeLanguage("fr")}
                    className="px-4 py-2 text-[.7rem] cursor-pointer hover:bg-gray-100 flex items-center gap-2">
                    <FlagIcon code="FR" size={16} /> Français
                  </div>
                  <div
                    onClick={() => handleChangeLanguage("en")}
                    className="px-4 py-2 text-[.7rem] cursor-pointer hover:bg-gray-100 flex items-center gap-2">
                    <FlagIcon code="GB" size={16} /> Anglais
                  </div>
                </div>
              )}
            </div>
          </li>
        </ul>
        <button onClick={handleMenuOpen} className="max-md:py-2 openm show">
          <Menu01Icon color="white" size={25} />
        </button>
        <button className="max-md:py-2 closem unshow" onClick={handleMenuClose}>
          <Cancel01Icon color="white" size={25} />
        </button>
      </div>
    </>
  );
}
